import { ONBOARDING_RUNGS, } from '../types/index.js';
export const DEFAULT_CHATBOT_HANDLE = 'chatbot';
export const INVITATION_SUPPRESS_DAYS = 7;
export const SNOOZE_DAYS = 7;
export const MS_PER_DAY = 24 * 60 * 60 * 1000;
export const DEFAULT_ENABLED_RUNGS = ONBOARDING_RUNGS.filter((rung) => rung !== 'deeper_share');
export const DEFAULT_ONBOARDING_GUIDE_CONFIG = {
    enabled: true,
    displayName: 'PeePs',
    subtitle: 'Community guide',
    tone: 'warm',
    quietHours: { startHour: 21, endHour: 8 },
    windowDays: 14,
    maxProactiveDmsPerDay: 1,
    maxProactiveDmsInWindow: 5,
    pushOnFirstIntro: false,
    enabledRungs: DEFAULT_ENABLED_RUNGS,
    primaryInvite: 'both',
    requiredIntake: false,
};
export const DEFAULT_ONBOARDING_GUIDE_STATE = {
    status: 'active',
    proactive: true,
    completedRungs: [],
    completedProactiveMessageKinds: [],
    invitationDismissals: [],
};
export const resolveOnboardingGuideConfig = (partial) => ({
    ...DEFAULT_ONBOARDING_GUIDE_CONFIG,
    ...partial,
    quietHours: {
        ...DEFAULT_ONBOARDING_GUIDE_CONFIG.quietHours,
        ...partial === null || partial === void 0 ? void 0 : partial.quietHours,
    },
    enabledRungs: (partial === null || partial === void 0 ? void 0 : partial.enabledRungs) && partial.enabledRungs.length > 0
        ? partial.enabledRungs
        : DEFAULT_ONBOARDING_GUIDE_CONFIG.enabledRungs,
});
export const resolveOnboardingGuideState = (partial) => {
    var _a, _b, _c, _d, _e;
    return ({
        ...DEFAULT_ONBOARDING_GUIDE_STATE,
        ...partial,
        status: (_a = partial === null || partial === void 0 ? void 0 : partial.status) !== null && _a !== void 0 ? _a : DEFAULT_ONBOARDING_GUIDE_STATE.status,
        proactive: (_b = partial === null || partial === void 0 ? void 0 : partial.proactive) !== null && _b !== void 0 ? _b : DEFAULT_ONBOARDING_GUIDE_STATE.proactive,
        completedRungs: (_c = partial === null || partial === void 0 ? void 0 : partial.completedRungs) !== null && _c !== void 0 ? _c : DEFAULT_ONBOARDING_GUIDE_STATE.completedRungs,
        completedProactiveMessageKinds: (_d = partial === null || partial === void 0 ? void 0 : partial.completedProactiveMessageKinds) !== null && _d !== void 0 ? _d : DEFAULT_ONBOARDING_GUIDE_STATE.completedProactiveMessageKinds,
        invitationDismissals: (_e = partial === null || partial === void 0 ? void 0 : partial.invitationDismissals) !== null && _e !== void 0 ? _e : DEFAULT_ONBOARDING_GUIDE_STATE.invitationDismissals,
    });
};
export const dayDurationMs = (virtualDayDurationMs) => virtualDayDurationMs !== null && virtualDayDurationMs !== void 0 ? virtualDayDurationMs : MS_PER_DAY;
export const daysBetween = (iso, now, virtualDayDurationMs) => (now.getTime() - new Date(iso).getTime()) /
    dayDurationMs(virtualDayDurationMs);
export const isSameLocalDay = (a, b) => a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();
export const isSameOnboardingDay = (a, b, virtualDayDurationMs) => virtualDayDurationMs
    ? Math.floor(a.getTime() / virtualDayDurationMs) ===
        Math.floor(b.getTime() / virtualDayDurationMs)
    : isSameLocalDay(a, b);
export const isQuietHour = (now, quietHours) => {
    const hour = now.getHours();
    const { startHour, endHour } = quietHours;
    if (startHour === endHour)
        return false;
    if (startHour < endHour)
        return hour >= startHour && hour < endHour;
    return hour >= startHour || hour < endHour;
};
export const isWithinOnboardingWindow = (createdAt, windowDays, now, virtualDayDurationMs) => {
    if (!createdAt)
        return true;
    return daysBetween(createdAt, now, virtualDayDurationMs) < windowDays;
};
export const isSnoozed = (state, now) => !!state.snoozedUntil &&
    new Date(state.snoozedUntil).getTime() > now.getTime();
export const isInvitationSuppressed = (state, surface, now, suppressDays = INVITATION_SUPPRESS_DAYS, virtualDayDurationMs) => {
    var _a;
    const last = [...((_a = state.invitationDismissals) !== null && _a !== void 0 ? _a : [])]
        .reverse()
        .find((dismissal) => dismissal.surface === surface);
    if (!last)
        return false;
    if (last.forever)
        return true;
    return daysBetween(last.at, now, virtualDayDurationMs) < suppressDays;
};
export const isProactiveAllowed = ({ config, state, createdAt, now, }) => {
    if (!config.enabled)
        return false;
    const snoozeExpired = !!state.snoozedUntil &&
        new Date(state.snoozedUntil).getTime() <= now.getTime();
    if (!state.proactive && !snoozeExpired)
        return false;
    if (state.status === 'muted')
        return false;
    if (state.status === 'quiet' && !snoozeExpired)
        return false;
    if (isSnoozed(state, now))
        return false;
    if (!isWithinOnboardingWindow(createdAt, config.windowDays, now, config.virtualDayDurationMs)) {
        return false;
    }
    return true;
};
export const canSendProactiveDm = ({ config, state, createdAt, now, }) => {
    var _a, _b;
    if (!isProactiveAllowed({ config, state, createdAt, now }))
        return false;
    if (config.primaryInvite === 'dock')
        return false;
    if (isQuietHour(now, config.quietHours))
        return false;
    if (config.maxProactiveDmsPerDay <= 0)
        return false;
    if (((_a = state.proactiveCount) !== null && _a !== void 0 ? _a : 0) >= config.maxProactiveDmsInWindow) {
        return false;
    }
    if (state.lastProactiveAt &&
        isSameOnboardingDay(new Date(state.lastProactiveAt), now, config.virtualDayDurationMs) &&
        ((_b = state.proactiveDayCount) !== null && _b !== void 0 ? _b : 1) >= config.maxProactiveDmsPerDay) {
        return false;
    }
    return true;
};
export const shouldAutoOpenDock = ({ config, state, createdAt, now, }) => {
    if (!isProactiveAllowed({ config, state, createdAt, now }))
        return false;
    if (config.primaryInvite === 'dm_only')
        return false;
    if (isQuietHour(now, config.quietHours))
        return false;
    if (state.dockShownAt)
        return false;
    if (isInvitationSuppressed(state, 'dock', now, INVITATION_SUPPRESS_DAYS, config.virtualDayDurationMs)) {
        return false;
    }
    return true;
};
export const shouldShowFab = ({ config, state, createdAt, now, }) => {
    if (!config.enabled)
        return false;
    if (state.status === 'muted')
        return false;
    if (!isWithinOnboardingWindow(createdAt, config.windowDays, now, config.virtualDayDurationMs)) {
        return false;
    }
    if (isInvitationSuppressed(state, 'fab', now, INVITATION_SUPPRESS_DAYS, config.virtualDayDurationMs)) {
        return false;
    }
    return true;
};
export const shouldShowEmptyInvite = ({ config, state, createdAt, now, surface, }) => {
    if (!config.enabled)
        return false;
    if (state.status === 'muted')
        return false;
    if (!isWithinOnboardingWindow(createdAt, config.windowDays, now, config.virtualDayDurationMs)) {
        return false;
    }
    if (isInvitationSuppressed(state, surface, now, INVITATION_SUPPRESS_DAYS, config.virtualDayDurationMs)) {
        return false;
    }
    return true;
};
export const nextMissingRung = (completed, enabled) => enabled.find((rung) => !completed.includes(rung));
export const withDismissal = (state, surface, now, forever = false) => {
    var _a;
    return ({
        ...state,
        invitationDismissals: [
            ...((_a = state.invitationDismissals) !== null && _a !== void 0 ? _a : []),
            { surface, at: now.toISOString(), forever: forever || undefined },
        ],
    });
};
export const withSnooze = (state, now, days = SNOOZE_DAYS, virtualDayDurationMs) => ({
    ...state,
    proactive: false,
    status: 'quiet',
    snoozedUntil: new Date(now.getTime() + days * dayDurationMs(virtualDayDurationMs)).toISOString(),
});
export const withMute = (state, now) => withDismissal(withDismissal({ ...state, proactive: false, status: 'muted' }, 'dock', now, true), 'fab', now, true);
export const audienceIncludesHandle = (audience, handle) => {
    var _a;
    return (_a = audience === null || audience === void 0 ? void 0 : audience.some((p) => p.handle.toLowerCase() === handle.toLowerCase())) !== null && _a !== void 0 ? _a : false;
};
export const findGuideConversation = (conversations, chatbotId) => conversations.find((conversation) => {
    var _a, _b;
    const last = (_a = conversation[conversation.length - 1]) !== null && _a !== void 0 ? _a : conversation[0];
    return (_b = last === null || last === void 0 ? void 0 : last.audience) === null || _b === void 0 ? void 0 : _b.some((profile) => profile.id === chatbotId);
});
